<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4 class="heading semi-bold float-left">{{ title }}</h4>
      </div>
      <div class="grid-body">
        <div class="col-md-12" v-if="showFabricSelectionMode">
          <toggle-button v-model="manualFabricSelection" /> {{ fabricSelectionModeLabel }}<br /><br />
        </div>
        <div class="row">
          <form @submit.prevent="scanFabric()">
            <div v-if="manualFabricSelection">
              <div class="col-md-12">
                <div class="alert alert-primary" role="alert">
                  <strong
                    >Currently Default Unit for Length is In Centimeters
                    (cm)</strong
                  >
                </div>
              </div>
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert" v-if="error">
                  <strong>{{ error }}</strong>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row mt-15" v-if="fabrics">
                  <div class="col-md-12">
                    <label>Select Fabric</label>
                    <v-select
                      :options="allFabrics"
                      v-model="selectedFabricId"
                      label="production_name"
                      :reduce="(allFabrics) => allFabrics.id"
                      @input="onFabricChange"
                      placeholder="Choose One"
                    />
                  </div>
                </div>

                <div class="row mt-15" v-if="showFabricRolls">
                  <div class="col-md-12">
                    <label>Select Fabric roll</label>
                    <v-select
                      :options="currentFabricRolls"
                      v-model="selectedFabricRollId"
                      label="roll_code"
                      :reduce="(currentFabricRolls) => currentFabricRolls.id"
                      @input="onRollChange"
                      placeholder="Choose One"
                    />
                  </div>
                </div>

                <div class="row mt-15">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">Length</label>
                      <numkeyboard
                        expose-elem="selector"
                        v-model="length"
                        ok-text="OK"
                        text-align="left"
                        v-if="!cutWholeRoll"
                      ></numkeyboard>
                      <div class="alert alert-primary" role="alert" v-if="cutWholeRoll">
                        <strong>{{ convertRollLengthRemainingToMeter(selectedRoll) }}m</strong> from <strong>{{ selectedRoll.roll_code }}</strong> will be cut!
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="use-whole-roll">
                      <label for="use_whole_roll">
                        <input type="checkbox" value="yes" id="use_whole_roll"
                               v-model="cutWholeRoll" class="form-control"
                               :checked="cutWholeRoll ? 'checked' : ''"> Cut the whole roll.
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 external-order-label" v-if="showExternalOrderSelector">
                    <label for="is_external_order">
                      <input type="checkbox" value="yes" id="is_external_order"
                             v-model="isAnExternalOrder" class="form-control"
                             :checked="isAnExternalOrder ? 'checked' : ''"> Is this an external order? (i.e. the order is not in the Production System)
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="row" v-if="barcode">
                <div class="col-md-12">
                  <input
                    type="text"
                    v-model="orderNumber"
                    placeholder="ORNR"
                    class="form-control scan-shirt"
                  />
                </div>
              </div>


              <div class="row mt-15">
                <div class="col-md-12">
                  <button class="btn btn-success btn-block">Submit</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="grid-body">
        <h1 class="text-bold message">{{ message }}</h1>
        <br /><br />
      </div>
    </div>
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
// import numpad from 'jquery.numpad';
import numkeyboard from "vue-numkeyboard";
import "vue-numkeyboard/style.css";

export default {
  props: {
    title: {
      type: String,
    },
    type: {
      type: String,
    },
    barcode: {
      type: Boolean,
      default: false,
    },
    fabrics: {
      type: Boolean,
      default: true,
    },
    showFabricRolls: {
      type: Boolean,
      default: false,
    },
    showFabricSelectionMode: {
      type: Boolean,
      default: false,
    },
    fabricSelectionModeLabel: {
      type: String,
      default: 'Manual'
    },
    showExternalOrderSelector: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      allFabrics: [],
      currentFabricRolls: [],
      length: "",
      error: null,
      selectedFabricId: null,
      selectedFabricRollId: null,
      orderNumber: null,
      message: null,
      stillCut: false,
      fabricRollInUseId: null,
      cutWholeRoll: false,
      rollInUse: null,
      selectedRoll: null,
      manualFabricSelection: true,
      isAnExternalOrder: this.showExternalOrderSelector
    };
  },
  mounted() {
    $(".scan-shirt").focus();
    this.getFabrics();
  },
  methods: {
    async getFabrics() {
      let results = await axios({
        method: "get",
        url: "/v2/fabrics?as_dropdown=1",
      });
      this.allFabrics = results.data.data.collection;
    },
    async getFabricRolls(fabricId) {
      this.fabricRollInUseId = null;
      this.selectedFabricRollId = null;
      let results = await axios({
        method: "get",
        url: `/v2/fabrics/${fabricId}/rolls`,
      });
      this.rollInUse = null;
      this.currentFabricRolls = results.data.data.warehouse;
      if(results.data.data.in_use && results.data.data.in_use.length > 0) {
        this.rollInUse = results.data.data.in_use[0];
        this.rollInUse.roll_code += ' (IN USE)';
        this.fabricRollInUseId = this.rollInUse.id;
        this.currentFabricRolls.unshift(this.rollInUse);
      }

    },
    async scanFabric() {
      if (this.barcode) {
        this.message = this.orderNumber;
      }
      try {
        if (!this.selectedFabricId && this.fabrics) {
          this.error = "Please Select Fabric";
          return false;
        } else if (!this.cutWholeRoll && !this.length) {
          this.error = "Please Input Length";
          return false;
        } else if (this.barcode && !this.orderNumber && !this.isAnExternalOrder) {
          this.error = "Please Scan Product";
          return false;
        } else {
          $(".loading").show();
          this.error = null;
          let res = await axios.post("fabrics/scan", {
            fabric_id: this.selectedFabricId,
            length: this.length * 1,
            type: this.type,
            orderNumber: this.orderNumber,
            still_cut: this.stillCut,
            fabric_roll_id: this.selectedFabricRollId,
            cut_whole_roll: this.cutWholeRoll,
            is_external_order: this.isAnExternalOrder,
          });

          if (
            res.data.status &&
            (this.type === "shirt_order" ||
              this.type === "repair" ||
              this.type === "fabric_cutter")
          ) {
            const result = res.data.result;
            Swal.fire({
              type: "info",
              title: "Scan Successful",
              html:
                "Order Number : " +
                result.order +
                "<br/>" +
                "Amount of Cut: " +
                parseFloat(result.cut_length).toFixed(2) +
                "m<br/>" +
                "Roll width   : " +
                result.roll_width,
            });
          }
        }
        this.orderNumber = null;
        this.stillCut = false;
        this.selectedFabricId = null;
        this.selectedFabricRollId = null;
        this.cutWholeRoll = false;
        this.length = "";
        toastr.success("Success");
        $("#selector1").val("");
        $(".loading").hide();
      } catch (error) {
        $(".loading").hide();
        let message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Something Went Wrong. Please Try Again!";

        message = message.split("&&");

        if (message[0] === "not_enough") {
          let fabric_id = message[1];
          Swal.fire({
            title: "Warning",
            text: "Roll Should Be Empty",
            type: "warning",
            showCancelButton: true,
            showCloseButton: true,
            cancelButtonColor: "#3085d6",
            confirmButtonColor: "#ff5252",
            confirmButtonText: "Still Cut",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            cancelButtonText: "Withdraw New Roll",
          }).then((result) => {
            if (result.dismiss === "cancel") {
              this.$router.push("/fabric/roll/withdraw/" + fabric_id);
            } else if (result.value) {
              this.stillCut = true;
              this.scanFabric();
            }
          });
        } else {
          Swal.fire("ERROR", message[0], "error");
          this.barcode = null;
        }
      }
    },
    onFabricChange(fabricId) {
      if(this.showFabricRolls) {
        this.getFabricRolls(fabricId);
      }
    },
    onRollChange() {
      this.selectedRoll = this.currentFabricRolls.find((roll) => roll.id === this.selectedFabricRollId);
      console.log(this.selectedRoll);
    },
    convertRollLengthRemainingToMeter(roll) {
      let length = (roll.unit === 'y')
            ? roll.length_remaining * 0.9144
            : roll.length_remaining;
      return length.toFixed(2);
    }
  },
};
</script>

<style scoped lang="scss">
.scan-shirt {
  font-size: 90px !important;
  height: 200px;
}
.btn-lg {
  height: 50px;
  font-size: 25px;
}
.loading {
  font-size: 150px;
  position: absolute;
  top: 20%;
  text-align: center;
  width: 100%;
  left: 0px;
  right: 0px;
  display: none;
}
.message {
  font-size: 90px;
}
.use-whole-roll {
  margin-top: 35px;
  input {
    height: 15px;
    float: left;
    width: auto;
    margin-right: 10px;
    margin-top: 2px;
  }
}
.external-order-label {
  margin: 20px 10px;
  input {
    height: 15px;
    float: left;
    width: auto;
    margin-right: 10px;
    margin-top: 2px;
  }
}
</style>
